export default [
  {
    topTitle1: "Handelsbetingelser hos {FIRMANAVN}",
    topTitle2: "Generelle oplysninger",
    intro: {
      line1: "- Besøger vores hjemmeside",
      line2: "- Gennemfører et køb af vores produkter",
      line3: "- Opretter en konto",
      line4: "- Tilmelder dig vores nyhedsbrev",
    },
    section1: {
      title: "Priser",
      content:
        "Hos {FIRMANAVN} er alle priserne i danske kroner og angivet inkl. moms og afgifter. Vi forbeholder os ret til fra dag til dag at ændre i priserne uden forudgående samtykke. Der tages forbehold for udsolgte varer.",
    },
    section2: {
      title: "Betaling",
      content:
        "{FIRMANAVN} modtager betaling med VISA-Dankort, VISA, VISA Electron, Mastercard, MobilePay,. Betalingen vil først blive trukket på din konto, når varen afsendes. Alle beløb er i DKK. Danske kroner og incl. moms. Der tages forbehold for prisfejl og udsolgte/udgåede varer.",
    },
    section3: {
      title: "Reklamationsret",
      content:
        "Købelovens almindelige regler om reklamation og mangler gælder for køb foretaget på butikkens hjemmeside eller tilhørende underdomæner.",
      content2:
        "Den danske købelovs regler om mangler finder anvendelse, hvorefter du kan lave en indsigelse gældende overfor Restauranten (fx hvis dine varer er beskadiget eller, hvis leveringen på anden måde er mangelfuld). Når der er tale om fødevarer (som din ordre ofte vil omfatte), gør vi dog opmærksom på, at det vil være nødvendigt at reklamere straks eller hurtigst muligt efter modtagelse af varerne, hvis Restauranten skal kunne håndtere og imødekomme din reklamation",
    },
    section4: {
      title: "Refusion",
      content:
        "Hvis der er tale om refusion, bedes du medsende bankoplysninger i form af regnr og kontonr, så det aftalte beløb kan overføres. Disse oplysninger kan uden risiko oplyses pr. mail eller anden elektronisk form, da det ikke er følsomme oplysninger og kun vil blive anvendt til vores opfyldelse af refusionen.",
    },
    section5: {
      title: "Fortrydelsesret",
      content:
        "Ved bestilling af mad og drikke, gælder det ingen fortrydelsesret, jf. forbrugeraftaleloven - fortrydelsesrettens område, paragraf 17 stk. 2 og paragraf 9 stk. 2.",
      content2:
        "Du kan ikke fortryde ved blot at nægte modtagelse af varen, uden samtidig at give tydelig meddelelse herom.",
    },
    section6: {
      title: "Tilbagebetaling",
      content: "",
    },
    section7: {
      title: "Afhentning i butik",
      content:
        "På vores webshop er det muligt at vælge at afhente vores produkter i vores butik. På denne måde er det muligt at reservere en vare online, for derefter at afhente varen fysisk i vores butik. Da varen afhentes i vores butik, så gælder samme vilkår, som når du handler fysisk i vores butik.",
    },
    section8: {
      title: "Alkohol",
      content:
        "Iflg. Dansk lovgivning skal personen være minium 18 år for at købe alkohol over 16,50%. For køb af alkohol under 16,50% skal personen være fyldt 16 år. Vi forbeholder os ret til at bede om fremvisning af gyldigt billed-ID som aldersdokumentation i tvivlstilfælde.",
    },
    section9: {
      title: "Persondatapolitik",
      content:
        "For at du kan indgå aftale med os og handle på vores hjemmeside, har vi brug for følgende oplysninger om dig:",
      intro: {
        line1: "Navn",
        line2: "Adresse",
        line3: "Telefonnummer",
        line4: "E-mailadresse",
        line5: "Oplysning om hvad du har købt",
      },
      content2:
        "Vi behandler dine personoplysninger med det formål, at kunne levere varen til dig, og for at kunne behandle henvendelser vedrørende dit køb. Behandlingen sker efter reglerne i vores persondatapolitik for {FIRMANAVN}. Heri kan du læse mere om, hvordan dine oplysninger behandles, hvornår de slettes, og hvilke rettigheder du har som registreret.",
    },
    section10: {
      title: "Klagemuligheder – oversigt og links:",
      content:
        "Har du en klage over et produkt, købt i vores Webshop, kan der sendes en klage til: Konkurrence- og Forbrugerstyrelsens Center for Klageløsning",
      intro: {
        line1: "Carl Jacobsens Vej 35",
        line2: "2500 Valby",
        line3: "Link: www.forbrug.dk",
      },
      content2:
        "Hvis du er forbruger med bopæl i et andet EU-land, kan du angive din klage i EU Kommissionens online klageplatform.",
      content3: "Platformen findes her: http://ec.europa.eu/consumers/odr/",
      content4:
        "Angiver du en klage her, skal du oplyse vores E-mail adresse: {MAILADRESSE}",
    },
  },
];
